<script>
import {
  CdrGrid,
  CdrText,
  CdrLink,
} from '@rei/cedar';
import analytics from '../../common/analytics';

export default {
  name: 'GiftcardHeaderComponent',
  components: {
    CdrGrid,
    CdrText,
    CdrLink,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    question: {
      type: String,
      required: true,
    },
    ctaBalance: {
      type: Object,
      required: true,
    },
    ctaHowTo: {
      type: Object,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
    pageDescription: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      urlCtaBalance: this.$props.ctaBalance.url,
      urlCtaHowTo: this.$props.ctaHowTo.url,
      analytics,
    };
  },
  computed: {
    validProps() {
      return (this.title && this.question && (typeof this.ctaBalance !== 'undefined') && (typeof this.ctaHowTo !== 'undefined'));
    },
  },
};
</script>
<template>
  <div
    v-if="validProps"
    data-ui="header-content"
    class="giftcard-header__content container-static"
  >
    <cdr-text
      :class="[
        'giftcard-header__title',
        {
          'giftcard-header__title--no-description': !description,
        }
      ]"
      tag="h1"
      data-ui="page-title"
    >
      {{ title }}
    </cdr-text>
    <div
      class="giftcard-header__body"
    >
      <div
        v-if="description"
        class="giftcard-header__description"
        data-ui="page-header-description"
        data-ui-analytic="link"
        v-html="description"
      />
      <cdr-grid
        class="giftcard-header__container"
        gutter="none"
      >
        <div class="giftcard-header__container-left">
          <cdr-text
            class="giftcard-header__question"
            data-ui="page-header-already-gift-card"
            tag="p"
          >
            {{ question }}
          </cdr-text>
          <cdr-link
            class="giftcard-header__balance"
            tag="a"
            data-ui="btn-check-balance"
            :href="urlCtaBalance"
            @click="analytics.click({
              linkName: `${siteId}:${pageDescription}_check balance`
            });"
          >
            {{ ctaBalance.name }}
          </cdr-link>
        </div>
        <div class="giftcard-header__container-right">
          <cdr-text
            class="giftcard-header__question"
            data-ui="page-header-have-questions"
            tag="p"
          >
            Have questions?
          </cdr-text>
          <cdr-link
            :href="'' + urlCtaHowTo"
            class="giftcard-header__how"
            data-ui="link-use-gift-card"
            @click="analytics.click({
              linkName: `${siteId}:${pageDescription}_how to use your gift card`
            });"
          >
            {{ ctaHowTo.name }}
          </cdr-link>
        </div>
      </cdr-grid>
    </div>
  </div>
</template>
